import { useState, useEffect } from "react";
import { Popover } from "../../../../components/Popover";
import { TextField } from "../../../../components/TextField";
import Button from "../../../../components/Button";
import Flex from "../../../../components/Flex";

type YouTubePopoverProps = {
  open: boolean;
  anchorRect: DOMRect | null;
  onSave: (url: string) => void;
  onCancel: () => void;
};

export const YouTubePopover = ({
  open,
  anchorRect,
  onSave,
  onCancel,
}: YouTubePopoverProps) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (open) setUrl("");
  }, [open]);

  const handleSave = () => {
    const trimmedUrl = url.trim();
    if (trimmedUrl) onSave(trimmedUrl);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
    if (e.key === "Escape") onCancel();
  };

  return (
    <Popover open={open} placement="bottom" onClose={onCancel}>
      <Popover.Trigger>
        {({ ref }) => (
          <button
            ref={ref}
            type="button"
            tabIndex={-1}
            aria-hidden
            style={{
              position: "fixed",
              top: anchorRect?.bottom ?? 0,
              left: anchorRect?.left ?? 0,
              width: anchorRect?.width ?? 0,
              height: 0,
              visibility: "hidden",
              pointerEvents: "none",
            }}
          />
        )}
      </Popover.Trigger>
      <Popover.Content>
        <Flex
          direction="column"
          gap={3}
          style={{ minWidth: 280 }}
          onKeyDown={handleKeyDown}
        >
          <TextField
            label="YouTube URL"
            required
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://www.youtube.com/watch?v=..."
          />
          <Flex gap={2} justifyContent="flex-end">
            <Button appearance="ghost" size="small" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              appearance="primary"
              size="small"
              onClick={handleSave}
              disabled={!url.trim()}
            >
              Save
            </Button>
          </Flex>
        </Flex>
      </Popover.Content>
    </Popover>
  );
};

YouTubePopover.displayName = "YouTubePopover";
